import { Finder, Pagination } from '@ekkogmbh/apisdk';
import { ListItemText, SelectProps } from '@mui/material';
import React, { useCallback } from 'react';
import PaginatedSelect from 'src/Common/Components/Forms/PaginatedSelect';
import useEkko from 'src/Common/Providers/EkkoProvider';
interface Props {
  coordinate: string;
  selected?: Pick<Finder, 'name' | 'coordinate'>;
  optional?: boolean;
  onChange: (finder: Finder | undefined) => void;
  disabled?: boolean;
  renderValue?: SelectProps['renderValue'];
  label?: string;
}

export const FinderPicker = ({ label, selected, onChange, ...props }: Props): React.JSX.Element => {
  const { api } = useEkko();

  const fetchFinders = useCallback((pagination: Pagination) => api.getFinders(pagination), [api]);

  return (
    <PaginatedSelect
      {...props}
      fetchPaginatedItems={fetchFinders}
      label={label ?? 'Finder'}
      itemId={(f: Finder) => f.coordinate + '::' + f.name}
      itemRender={(f: Finder) => <ListItemText primary={f.name} secondary={f.coordinate} />}
      onChange={(f) => onChange(f as Finder | undefined)}
      value={selected as Finder}
    />
  );
};
